<template>
  <v-form>
    <!--Кнопка добавить акионний набор-->
    <div class="d-flex">
    <v-btn
      v-if="isManager || isAdmin"
      class="mb-3 mr-3"
      color="primary" 
      min-width="150"
      :disabled="action.all_products ? true : false"
      @click="addActionProdset()"
    >
      Створити акційний набір 
    </v-btn>
    <v-checkbox
      v-if="isManager || isAdmin"
      class="mb-3 mr-3"
      v-model="action.all_products"
      :disabled="action.prodsets?.length > 0 ? true : false"
      label="Всі товари"
      @change="toggleAllProducts()"
    /> 
    <v-select
      return-object
      v-if="isManager || isAdmin"
      class="mb-3 mr-3"
      item-text="name"
      item-value="id"
      v-model="site_st"
      :items="sitesSt"
      label="Ціноутворення сайту"
      :disabled="action.all_products ? false : true"
      clearable
      @change="setSiteSt"
    ></v-select>

    </div>  
    <!--Наборы-->
    <v-card 
      class="mb-6"
      v-for="(prodset, key) in action.prodsets" 
      :key="prodset.prodset_id">
     
     <!--Набір-->
      <v-card-title class="justify-space-between font-weight-black text-h4">
        <span>
          Набір {{ key + 1 }} (id: {{ prodset.prodset_id }})
        </span>
        <span>
          <span>
            <v-btn
              v-if="isManager || isAdmin"
              class="mr-3"
              color="success" 
              small
              @click="addActionLot(prodset.prodset_id)"
            >
              Створити подарунковий лот 
            </v-btn>
          </span>

          <v-icon
            v-if="isAdmin"
            title="Видалити цей акційний набір"
            color="error"
            @click="deleteActionProdset(prodset.prodset_id)"
          >
            mdi-delete
          </v-icon>
        </span>
      </v-card-title>

      <v-card>
        <v-alert
          class="overflow-x-scroll"
          border="left"
          colored-border
          color="deep-orange"
        >
          <!--Акційні товари-->
          <div class="pr-5 pl-4">
            Акційні товари
          </div>

          <v-simple-table dense>
            <thead>
              <tr>
                <th width="140" class="primary--text">
                  Код товару
                </th>
                <th width="140" class="primary--text">
                  Код Тайфун
                </th>
                <th style="min-width: 200px" class="primary--text">
                  Назва
                </th>
                <th width="120" class="primary--text">
                  Тип ціни
                </th>
                <th width="100" class="primary--text">
                  Ціна
                </th>
                <th width="50"></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="position in prodset.positions" :key="position.id">
                <td>{{ position.id }}</td>
                <td>{{ position.typhoon_id }}</td>
                <td>
                  <a :href="position.link" target="_blank">{{ position.name }}</a>
                </td>
                <td>{{ listActionPriceTypeNames[position.price_type] }}</td>
                <td>{{ position.price }}</td>
                <td>
                  <span class="d-flex">
                    <v-icon
                      v-if="isManager || isAdmin"
                      class="mr-4"
                      color="green"
                      @click="toggleDialogActionProductEdit({
                        queryData: { 
                          action_id: action.id,
                          prodset_id: prodset.prodset_id, 
                          goods_id: position.goods_id,
                          position_id: position.id,
                          link: position.link,
                          name: position.name,
                          price: position.price,
                          price_type_id: position.price_type,
                          typhoon_id: position.typhoon_id,
                        }, 
                        method: '/update-action-product',
                        isShow: true
                      })"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      v-if="isAdmin"
                      color="error"
                      @click="deleteActionProduct(prodset.prodset_id, position)"
                    >
                      mdi-delete
                    </v-icon>
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>

          <div class="d-flex justify-end mt-3">
            <!--Додати акційний товар -->
          <v-btn v-if="isManager || isAdmin" class="mr-3"
              color="deep-orange" 
              outlined
              small
            @click="exportXlsx({prodsetId: prodset.prodset_id})"><v-icon>mdi-export</v-icon>&nbsp;Експорт XLSX</v-btn>
          <v-btn v-if="isManager || isAdmin"   class="mr-3"
              color="deep-orange" 
              outlined
              small
            @click="importXlsx({prodsetId: prodset.prodset_id})"><v-icon>mdi-import</v-icon>&nbsp;Імпорт XLSX</v-btn>

            <v-btn
              v-if="isManager || isAdmin"
              color="deep-orange" 
              outlined
              small
              @click="toggleDialogActionProductAdd({
                queryData: { 
                  prodset_id: prodset.prodset_id, 
                  action_id: action.id 
                }, 
                method: '/add-action-product',
                isShow: true
              })"
            >
              Додати акційний товар 
            </v-btn>
          </div>
        </v-alert>

        <!--Лоты-->
        <v-card v-for="(lot, key) in prodset.lots" :key="lot.lot_id" v-if="lot">
          <v-alert
            class="overflow-x-scroll"
            border="left"
            colored-border
            color="success"
          >
            <div class="d-flex justify-space-between pr-5 pl-4">
              <span>
                Подарунковий ЛОТ {{ key + 1 }} (id:{{ lot.lot_id }})
              </span>

              <span>
                <v-icon
                  v-if="isAdmin"
                  title="Видалити подарунковий ЛОТ"
                  color="error"
                  @click="deleteActionLot(prodset.prodset_id, lot.lot_id)"
                >
                  mdi-delete
                </v-icon>
              </span>
            </div>

            <v-simple-table dense>
              <thead>
                <tr>
                  <th width="140" class="primary--text">
                    Код товару
                  </th>
                  <th width="140" class="primary--text">
                    Код Тайфун
                  </th>
                  <th class="primary--text">
                    Назва
                  </th>
                  <th width="120" class="primary--text">
                    Тип ціни
                  </th>
                  <th width="100" class="primary--text">
                    Ціна
                  </th>
                  <th width="50"></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="lot_position in lot.lot_positions" :key="lot_position.id">
                  <td>{{ lot_position.id }}</td>
                  <td>{{ lot_position.typhoon_id }}</td>
                  <td>
                    <a :href="lot_position.link" target="_blank">{{ lot_position.name }}</a>
                  </td>
                  <td>{{ listActionPriceTypeNames[lot_position.price_type] }}</td>
                  <td>{{ lot_position.price }}</td>
                  <td>
                    <span class="d-flex">
                      <v-icon
                        v-if="isManager || isAdmin"
                        class="mr-4"
                        color="green"
                        @click="toggleDialogActionProductEdit({
                          queryData: { 
                            action_id: action.id,
                            prodset_id: prodset.prodset_id, 
                            lot_id: lot.lot_id, 
                            goods_id: lot_position.goods_id,
                            lot_position_id: lot_position.id,
                            link: lot_position.link,
                            name: lot_position.name,
                            price: lot_position.price,
                            price_type_id: lot_position.price_type,
                            typhoon_id: lot_position.typhoon_id,
                          }, 
                          method: '/update-action-lot-product',
                          isShow: true
                        })"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                        v-if="isAdmin"
                        color="error"
                        @click="deleteActionLotProduct(lot.lot_id, prodset.prodset_id, lot_position)"
                      >
                        mdi-delete
                      </v-icon>
                    </span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <div class="d-flex justify-end mt-3">
              <!--Додавання товару в лот -->
              <v-btn
                v-if="isManager || isAdmin"
                color="success" 
                outlined
                min-width="150"
                small
                @click="toggleDialogActionProductAdd({
                  queryData: { 
                    prodset_id: prodset.prodset_id, 
                    lot_id: lot.lot_id, 
                    action_id: action.id 
                  }, 
                  method: '/add-action-lot-product',
                  isShow: true
                })"
              >
                Додати товар в лот
              </v-btn>
            </div>
          </v-alert>
        </v-card>
      </v-card>
    </v-card>

    <DialogActionProductAdd
      :actionPriceTypeList="actionPriceTypeList" 
      :queryData="productQueryData"
      :methodUrl="productMethod"
      @dialog:close="toggleDialogActionProductAdd({queryData: {}, method: '', isShow: false})"
      v-if="isShowDialogActionProductAdd"
    />

    <DialogActionProductEdit
      :actionPriceTypeList="actionPriceTypeList" 
      :queryData="productQueryData"
      :methodUrl="productMethod"
      @dialog:close="toggleDialogActionProductEdit({queryData: {}, method: '', isShow: false})"
      v-if="isShowDialogActionProductEdit"
    />

    <!--Диалоговое окно для удаления-->
    <DialogConfitmDelete ref="dialogConfirmDelete" />
    <Preloader v-if="isSending" />
    <v-dialog v-model="uploadDialog" max-width="600">
        <v-card class="pa-2 pa-md-4">
            <v-card-title class="text-h5 justify-space-between">
                Завантажити акційні товари
            </v-card-title>
            <v-card-text class="px-4">
                <v-file-input v-model="uploadFile" :rules="[v => !!v ]"
                    accept=".xlsx" label="Виберіть файл .xlsx" outlined dense></v-file-input>
                    <p class="pb-8 px-10"> 
                    <b>Формат файлу (порядок колонок):</b> <br>
                      1. Назва товару<br>
                      2. Код Тайфун товару<br>
                      3. Назва ціноутворення<br>
                      4. ID ціноутворення<br>
                      5. Ціноутворення<br>
                    </p>
                <v-btn :disabled="!uploadFile" @click="upload()" color="primary"
                    :loading="uploadLoading">
                    Завантажити
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-dialog v-model="report" max-width="600">
        <v-card class="pa-2 pa-md-4">
            <v-card-title class="text-h5 justify-space-between">
                Результат завантаження товарів
            </v-card-title>
            <v-card-text class="px-4 mb-6">
              Рядків у файлі: {{ reportData.rows }}<br>
              Оновлено: {{ reportData.updatedData }}<br>
            </v-card-text>
        </v-card>
    </v-dialog>

  </v-form>
</template>

<script>
import DialogActionProductAdd from './DialogActionProductAdd.vue';
import DialogActionProductEdit from './DialogActionProductEdit.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { HTTP } from '@/http-common';

export default { 
  name: 'TabSets',
  inject: ['getAction'],

  data() {
    return {
      // Показать / скрыть диалоговое окно добавления товара
      isShowDialogActionProductAdd: false,
      // Показать / скрыть диалоговое окно редактирования товара
      isShowDialogActionProductEdit: false,
      // Указывает на то что в данный момент отправляются данные на сервер
      isSending: false,
      // Данные товара добавления / изменения
      productQueryData: {},
      // Метод
      productMethod: "",
      sitesSt: [],
      site_st: null,
      xlsLoading: false,
      fileName: "",
      fileBlobURL: "",
      mime: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        xml: "application/xml",
      },
      uploadDialog: false,
      uploadFile: null,
      uploadLoading: false,
      uploadProdsetId: null,
      report: false,
      reportData: {
        totalRows: 0,
        updated: 0,
        added: 0,
      },

    }
  },

  components: {
    DialogActionProductAdd,
    DialogActionProductEdit,
  },
  
  props: {
    // Акция
    action: {
      type: Object,
      default: () => {},
    },
    // Список типов ценообразований
    actionPriceTypeList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters(['isManager', 'isAdmin']),

    listActionPriceTypeNames() {
      let items = {};
      for(let item of this.actionPriceTypeList) {
        items[item.id] = item.name;
      }
      return items;
    }
  },
  mounted() {
    this.getListShopModulesSites();
  },
  methods: {
    ...mapMutations(['setSnackbar']),
    
    // Створити акційний набір 
    async addActionProdset() {
      this.isSending = true;

      try {
        await HTTP.post('/add-action-prodset', { action_id: this.action.id });
        this.setSnackbar({ type: 'success', text: 'Успiшно створено' });
        await this.getAction();
      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },

    // Видалити акційний набір 
    async deleteActionProdset(prodset_id) {
      let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
      if (!isConfirmDelete) return;
      this.isSending = true;

      try {
        await HTTP.post('/delete-action-prodset', { 
          action_id: this.action.id,
          prodset_id,
        });
        this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
        await this.getAction();
      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },

    // Створити акційний лот
    async addActionLot(prodset_id) {
      this.isSending = true;

      try {
        await HTTP.post('/add-action-lot', { 
          action_id: this.action.id,
          prodset_id,
        });
        this.setSnackbar({ type: 'success', text: 'Успiшно створено' });
        await this.getAction();
      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },

    // Видалення лоту з набору акції
    async deleteActionLot(prodset_id, lot_id) {
      let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
      if (!isConfirmDelete) return;
      this.isSending = true;
      
      try {
        await HTTP.post('/delete-action-lot', { 
          action_id: this.action.id,
          prodset_id,
          lot_id,
        });
        this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
        await this.getAction();
      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },


    // Видалення лоту з набору акції
    async deleteActionLotProduct(lot_id, prodset_id, product) {
      let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
      if (!isConfirmDelete) return;
      this.isSending = true;

      let productId = product.id;
      delete product.id;

      try {
        await HTTP.post('/delete-action-lot-product', {
          ...product, 
          lot_id, 
          prodset_id,
          action_id: this.action.id,
          lot_position_id: productId,
        });
        this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
        await this.getAction();
      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },

    // Видалення акційного товару з акції 
    async deleteActionProduct(prodset_id, product) {
      let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
      if (!isConfirmDelete) return;
      this.isSending = true;

      let productId = product.id;
      delete product.id;

      try {
        await HTTP.post('/delete-action-product', {
          ...product, 
          prodset_id,
          action_id: this.action.id,
          position_id: productId,
        });
        this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
        await this.getAction();
      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.isSending = false;
      }
    },

    // Показать / скрыть модальное окно добавление товара
    toggleDialogActionProductAdd({queryData, method, isShow}) {
      this.productQueryData = queryData;
      this.productMethod = method;
      this.isShowDialogActionProductAdd = isShow;
    },

    // Показать / скрыть модальное окно редактирования товара
    toggleDialogActionProductEdit({queryData, method, isShow}) {
      this.productQueryData = queryData;
      this.productMethod = method;
      this.isShowDialogActionProductEdit = isShow;
    },
    async getListShopModulesSites() {
        // Получаем список типов ценообразования
        try {
          const { data } = await HTTP.post('/get-list-shop-modules-sites', { 
            lang_key: 'ua', 
          });
          setTimeout(() => {
            this.sitesSt = data?.content || [];
            this.site_st = this.sitesSt.find(item => item.id === this.action.site_st) || null;
          }, 1000);

        } catch(error) {
          console.warn(error);
        }
    },
    async toggleAllProducts(){
      // Если выбрано "Все товары", то очищаем выбранный сайт
        this.$set(this.action, 'site_st', null);
        this.site_st = null;
        if (this.site_st || !this.action.all_products) {
          this.saveAction();
        }
    },
    // Устанавливаем выбранный сайт
    setSiteSt(event) {
      this.$set(this.action, 'site_st', this.site_st?.id || null);
      this.saveAction();
    },

    async saveAction() {
      try {
        let { id, mis_id, archive, main, singly_main, mechanic, type, date_from, date_to, url, langs, all_products, site_st } = this.action;
        await HTTP.post('/update-action', {
          id,
          mis_id,
          archive,
          main,
          singly_main,
          mechanic: mechanic.name,
          mechanic_id: mechanic.id,
          action_type: type.name,
          action_type_id: type.id,
          date_from,
          date_to,
          url,
          langs,
          all_products,
          site_st
        });
        await this.getAction();
        this.setSnackbar({ 
          type: 'success', 
          text: `Акцію збережено.` 
        });

      } catch(error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
        this.isSending = false;
      }
    },
    exportActionPositions({prodset_id}) {
      return HTTP.post('/export-action-positions', { action_id: this.action.id, prodset_id }, {
        
      });
    },
    exportXlsx({prodsetId}) {
      if (this.fileBlobURL) {
        window.URL.revokeObjectURL(this.fileBlobURL);
      }
      this.xlsLoading = true;
      
      this.exportActionPositions({ prodset_id: prodsetId })
      .then((response) => {
        // Якщо HTTP повертає об'єкт відповіді Axios: response.data.content
        // Якщо ваш HTTP-клієнт вже повертає самі дані: response.content
        const base64String = response.data ? response.data.content : response.content;
        
        this.saveData(base64String, "action-positions.xlsx");
        this.xlsLoading = false;
      })
      .catch((error) => {
        console.error("Помилка експорту:", error);
        this.xlsLoading = false;
      });
    },
    saveData(base64String, fileName) {
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      
      // Тепер сюди приходить рядок, і помилки не буде
      var buf = Buffer.from(base64String, "base64"); 
      const blob = new Blob([buf], {
        type: this.mime["xlsx"], // Впевніться, що this.mime["xlsx"] існує
      });
      
      let url = window.URL.createObjectURL(blob);
      this.fileBlobURL = a.href = url;
      a.download = fileName;
      a.click();
      
      // Очищення DOM після завантаження
      document.body.removeChild(a);
    },
    importXlsx({prodsetId}) {
      this.uploadProdsetId = prodsetId;
      this.uploadDialog = true;
      this.uploadFile = null;
      this.reportData = {
        totalRows: 0,
        updated: 0,
        added: 0,
      };
    },
    async upload() {
      this.uploadLoading = true;
      const formData = new FormData();
      formData.append("file", this.uploadFile);
      formData.append("action_id", this.action.id);
      formData.append("prodset_id", this.uploadProdsetId);
      try {
        let { data } = await HTTP.post('/import-action-positions', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.reportData = data?.content || {};
        this.report = true;
        this.uploadDialog = false;
        this.getAction();
      } catch (error) {
        console.warn(error);
        this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
      } finally {
        this.uploadLoading = false;
      }
    }
   
  },
}
</script>

<style scoped lang="sass">
  .overflow-x-scroll
    overflow-x: auto
</style>
